import script from "./AppContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppContainer.vue?vue&type=script&setup=true&lang=ts"

import "./AppContainer.vue?vue&type=style&index=0&id=bef8c220&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bef8c220"]])

export default __exports__